import { variant } from 'variant';
import type { VariantOf } from 'variant';

export const ScreenState = variant({
  Home: {},
  SiteSelector: {},
});

export type ScreenState = VariantOf<typeof ScreenState>;
